import { UserRole } from '@shared/services';

enum Resources {
  ADMIN = '/admin',
  INSPECTOR = '/inspector',
}

const roleResourcesMap: Record<UserRole, Resources[]> = {
  [UserRole.COMPANY_ADVANCED_USER]: [Resources.ADMIN],
  [UserRole.COMPANY_STANDARD_USER]: [Resources.ADMIN],
  [UserRole.COMPANY_ROOT]: [Resources.ADMIN],
  [UserRole.COMPANY_ADMIN]: [Resources.ADMIN],
  [UserRole.COMPANY_LOCATION_MANAGER]: [Resources.ADMIN],
  [UserRole.COMPANY_READ_ONLY_USER]: [Resources.ADMIN],
  [UserRole.COMPANY_INSPECTOR_COORDINATOR]: [Resources.ADMIN],
  [UserRole.FLOORING_DEALERSHIP_MANAGER]: [Resources.ADMIN],
  [UserRole.FLOORING_FINANCE_MANAGER]: [Resources.ADMIN],
  [UserRole.FLOORING_MANAGER]: [Resources.ADMIN],
  [UserRole.FLOORING_AUDITOR]: [Resources.ADMIN],
  [UserRole.INSPECTOR]: [Resources.INSPECTOR],
  [UserRole.PROVEN_INSPECTOR]: [Resources.INSPECTOR],
  // Training / audit roles do inspector work, so they land on the same resource.
  [UserRole.TRAINEE_INSPECTOR]: [Resources.INSPECTOR],
  [UserRole.AUDITOR]: [Resources.INSPECTOR],
  [UserRole.SUPER_ADMIN]: [Resources.ADMIN, Resources.INSPECTOR],
  [UserRole.COMPANY_CUSTOMS_USER]: [Resources.ADMIN],
};

export function resourcePathByRole(role: UserRole) {
  return roleResourcesMap[role];
}
